import { render, staticRenderFns } from "./training_number.vue?vue&type=template&id=fbab29a0&scoped=true&"
import script from "./training_number.vue?vue&type=script&lang=js&"
export * from "./training_number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbab29a0",
  null
  
)

export default component.exports